<template>
  <div>
    <v-row dense align="center" class="mb-3">
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>

    <v-row dense align="center" class="mb-3">
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>

    <v-row dense align="center">
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
      <v-col>
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "MedicalRequestListSkeletonLoader",
};
</script>

<style></style>
